import React from 'react';
import { cn } from './cn';

type Size = 'sm' | 'md' | 'lg';
type Variant = 'default' | 'glass' | 'ghost';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  size?: Size;
  variant?: Variant;
  /** required for accessibility */
  ariaLabel: string;
}

const sizeClasses: Record<Size, string> = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
};

const variantClasses: Record<Variant, string> = {
  default: 'bg-bg-3 text-text-primary hover:bg-bg-4',
  glass: 'bg-white/5 backdrop-blur-glass text-text-primary hover:bg-white/10 border border-light',
  ghost: 'bg-transparent text-text-secondary hover:bg-white/5 hover:text-text-primary',
};

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { icon, size = 'md', variant = 'default', ariaLabel, className, ...rest },
  ref
) {
  return (
    <button
      ref={ref}
      aria-label={ariaLabel}
      className={cn(
        'inline-flex items-center justify-center rounded-full transition-all duration-150 ease-out-quint disabled:opacity-50 disabled:cursor-not-allowed',
        sizeClasses[size],
        variantClasses[variant],
        'hover:-translate-y-px hover:shadow-2',
        className
      )}
      {...rest}
    >
      {icon}
    </button>
  );
});
